// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b30f73aa","513":"4414a90a","703":"20221138"}[chunkId] + ".chunk.js";
};